import { useState } from "react";
import { closeSnackbar } from "notistack";
import CloseIcon from "@mui/icons-material/Close";
import { Tooltip, Box } from "@mui/material";

type SnackbarActionProps = {
  id: string | number;
  text?: string;
};

export function SnackbarDismissAction({ id, text = "Dismiss" }: SnackbarActionProps) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  return (
    <Tooltip
      title={text}
      open={tooltipOpen}
      onOpen={() => setTooltipOpen(true)}
      onClose={() => setTooltipOpen(false)}
    >
      <Box
        onClick={() => {
            setTooltipOpen(false);
            closeSnackbar(id);
        }}
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          p: 1,
          color: "inherit",
          "&:hover": {
            opacity: 0.7,
          },
        }}
      >
        <CloseIcon fontSize="small" />
      </Box>
    </Tooltip>
  );
}
